import { Box } from "theme-ui";

export default function PrintIcon(props) {
  return (
    <Box
      as="svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 12.5H1.5C0.947715 12.5 0.5 12.0523 0.5 11.5V5.5C0.5 4.94772 0.947715 4.5 1.5 4.5H15.5C16.0523 4.5 16.5 4.94772 16.5 5.5V11.5C16.5 12.0523 16.0523 12.5 15.5 12.5H12.5"
        stroke="black"
      />
      <path d="M12.5 4.5V0.5H4.5V4.5" stroke="black" />
      <path d="M4.5 8.5H12.5V16.5H4.5V8.5Z" stroke="black" />
      <path
        d="M6.5 11.5H10.5M6.5 13.5H10.5"
        stroke="black"
        strokeLinecap="round"
      />
    </Box>
  );
}
